var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1303 330",
    enableBackground: "new 0 0 1303 330",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M896.500000,118.000000  C898.077454,119.058701 899.843628,118.465935 901.500000,118.466393  C1032.666626,118.502991 1163.833374,118.500000 1295.500000,118.500000  C1295.500000,129.995163 1295.598389,141.498764 1295.460327,152.999527  C1295.386353,159.165344 1296.104614,165.358688 1295.000000,171.500000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M897.500000,91.500000  C897.629883,92.518608 897.486145,93.427795 895.988037,94.238892  C894.935303,88.743629 895.839539,83.332947 895.409790,77.750000  C680.333618,77.750000 465.166809,77.750000 249.750000,77.750000  C249.750000,126.998878 249.750000,176.499435 249.750000,226.250000  C464.666412,226.250000 679.833191,226.250000 896.000000,226.250000  C896.000000,182.502472 896.000000,138.501236 896.000000,94.500000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M187.000000,89.500000  C206.501419,89.500000 226.002853,89.500000 245.500000,89.500000  C245.500000,98.000000 245.500000,106.000000 245.500000,114.448471  C166.003952,115.127670 86.504494,115.714767 6.750000,115.469765  C6.750000,172.999039 6.750000,230.499512 6.750000,288.500000  C8.321856,288.500000 10.160928,288.500000 12.000000,288.500000  C34.500000,288.500000 57.000038,288.517029 79.499916,288.465057  C81.156853,288.461243 82.922539,289.058685 84.500000,288.000000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M572.500000,63.000000  C572.500000,66.666664 572.500000,70.333336 572.500000,74.250000  C596.330994,74.250000 620.165527,74.250000 644.250000,74.250000  C644.250000,52.669212 644.250000,30.834606 644.250000,8.750000  C620.669006,8.750000 596.834473,8.750000 572.500000,8.750000  C572.500000,18.994709 572.500000,29.497355 572.500000,40.000000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M896.500000,196.500000  C953.333313,196.500000 1010.166687,196.500000 1067.078125,196.500000  C1067.992554,195.000000 1067.485718,193.500000 1067.000488,192.000000  C1031.000000,192.000000 995.000000,192.000000 958.686584,192.000000  C958.624878,193.322754 958.562439,194.661377 958.500000,196.000000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M450.500000,171.500000  C371.000000,171.500000 291.500000,171.500000 212.000000,171.500000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M819.500000,177.500000  C799.833313,177.500000 780.162842,177.729263 760.501648,177.401367  C750.954834,177.242157 741.498291,178.890091 732.002686,178.443375  C688.843994,176.413116 645.665833,177.874191 602.499207,177.675400  C595.714966,177.644165 588.921021,178.765671 581.997437,178.626038  C458.672974,176.138992 335.332489,178.150879 212.000000,177.500000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1295.000000,177.500000  C1296.058716,179.077469 1295.461548,180.843170 1295.465210,182.500076  C1295.516357,205.999969 1295.500000,229.500000 1295.500000,253.500000  C1271.168945,253.500000 1246.834473,253.500000 1222.500000,253.500000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1078.500000,177.000000  C1084.108765,180.119659 1090.200195,177.608963 1096.500000,178.800461  C1096.500000,203.331100 1096.500000,228.165543 1096.500000,253.250000  C1135.331909,253.250000 1174.165894,253.250000 1213.500000,253.250000  C1213.500000,230.669098 1213.500000,207.834549 1213.500000,185.000000  "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1072.000000,157.500000  C1070.765747,162.128540 1072.019287,166.845932 1071.343140,171.500000  C1032.500000,171.500000 993.500000,171.500000 954.500000,171.500000  C954.500000,198.666672 954.500000,225.833328 954.500000,253.250000  C993.331909,253.250000 1032.165894,253.250000 1071.500000,253.250000  C1071.500000,228.668900 1071.500000,203.834457 1071.500000,179.000000  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M63.500000,116.500000  C63.500000,173.500000 63.500000,230.500000 63.500000,287.500000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M597.500000,177.500000  C596.562378,176.908371 596.479614,176.027374 596.478638,175.000015  C596.472168,168.319061 596.898376,161.613419 595.070496,154.750000  C638.332031,154.750000 681.166016,154.750000 724.690674,154.750000  C723.123657,162.151245 723.545105,169.830688 723.500000,177.500000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M432.500000,62.500000  C486.000000,62.500000 539.500000,62.500000 593.250000,62.500000  C593.250000,55.341084 593.250000,48.170544 593.250000,40.750000  C532.667603,40.750000 471.833801,40.750000 410.750000,40.750000  C410.750000,47.658916 410.750000,54.829456 410.750000,62.264950  C411.908447,62.990520 413.505585,62.283146 415.000000,62.500000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M810.000000,171.500000  C716.500000,171.500000 623.000000,171.500000 529.500000,171.500000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1099.500000,154.000000  C1099.500000,155.333328 1099.500000,156.666672 1099.500000,158.250000  C1135.998535,158.250000 1172.499268,158.250000 1209.264893,158.250000  C1209.990479,157.091537 1209.283203,155.494431 1209.500000,154.000000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M958.500000,154.000000  C958.500000,155.333328 958.500000,156.666672 958.500000,158.250000  C994.665100,158.250000 1030.832520,158.250000 1067.264893,158.250000  C1067.990479,157.091537 1067.283203,155.494431 1067.500000,154.000000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1099.500000,185.000000  C1099.500000,186.000000 1099.500000,187.000000 1099.500000,188.250000  C1135.998535,188.250000 1172.499268,188.250000 1209.282715,188.250000  C1210.024292,187.455856 1209.256958,186.155746 1209.500000,185.000000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M958.500000,178.000000  C958.500000,181.333328 958.500000,184.666672 958.500000,188.250000  C994.665100,188.250000 1030.832520,188.250000 1067.282715,188.250000  C1068.024292,187.455856 1067.256958,186.155746 1067.500000,185.000000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1097.500000,244.500000  C1135.833374,244.500000 1174.166626,244.500000 1212.500000,244.500000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M955.500000,244.500000  C993.833313,244.500000 1032.166626,244.500000 1070.500000,244.500000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1209.500000,171.000000  C1209.397339,170.035324 1209.528687,168.950607 1207.999634,168.986938  C1205.834229,169.038422 1203.666626,169.000000 1201.500000,169.000000  C1167.666626,169.000000 1133.833374,169.000000 1099.815796,169.000000  C1099.677246,170.316650 1099.536743,171.652481 1099.380371,173.139511  C1099.977905,173.272507 1100.488892,173.485596 1101.000000,173.485825  C1135.666626,173.501465 1170.333496,173.523636 1204.999756,173.417282  C1206.451172,173.412811 1208.814697,174.944229 1209.500000,172.000000  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1096.000000,157.500000  C1097.150513,163.305222 1096.224365,169.169006 1096.480957,175.000839  C1096.631348,178.419769 1099.301392,181.486298 1102.500000,181.488052  C1137.166626,181.507172 1171.834595,181.372864 1206.498047,181.707916  C1209.759521,181.739441 1209.197998,177.724167 1212.000000,178.500000  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1210.500000,178.500000  C1209.465332,176.604141 1207.654419,177.004990 1206.000000,177.004684  C1171.666626,176.998474 1137.333374,176.998474 1103.000000,177.004669  C1101.345581,177.004974 1099.534668,176.604141 1098.500000,178.500000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1067.500000,171.000000  C1067.578125,169.588593 1067.111694,168.873184 1065.498047,168.965881  C1063.172363,169.099442 1060.833374,169.000000 1058.500000,169.000000  C1025.333374,169.000000 992.166687,169.000000 958.815613,169.000000  C958.677185,170.316650 958.536743,171.652481 958.380371,173.139511  C958.977905,173.272507 959.488892,173.485611 960.000000,173.485840  C994.333313,173.501480 1028.666748,173.523865 1062.999756,173.417267  C1064.451172,173.412766 1066.814697,174.944229 1067.500000,172.000000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1209.500000,150.000000  C1208.646240,148.956192 1207.487183,149.531876 1206.500000,149.530823  C1171.833374,149.493927 1137.166626,149.493912 1102.500000,149.530823  C1101.512817,149.531876 1100.353760,148.956192 1099.500000,150.000000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1281.500000,179.000000  C1281.500000,180.666672 1281.500000,182.333328 1281.500000,184.661453  C1174.166626,183.718140 1066.833374,184.053085 959.500000,184.000000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,181.500000  C994.166687,181.500000 1028.833496,181.472916 1063.499878,181.556030  C1066.027588,181.562088 1067.981201,181.413071 1068.247070,178.247086  C1068.333252,178.333374 1068.166626,178.166718 1068.000000,178.000031  C1067.833374,177.833328 1067.695312,177.599960 1067.494263,177.513321  C1067.011963,177.305527 1066.500122,177.021088 1066.000000,177.020752  C1031.833374,176.997879 997.666687,177.000000 963.500000,177.000000  C962.500000,177.000000 961.497192,176.951553 960.500549,177.009720  C958.165466,177.145981 955.833496,177.475342 953.500000,177.478302  C926.666687,177.512344 899.833313,177.500000 872.891663,177.500000  C872.009460,176.091537 872.716858,174.494431 872.500000,173.000000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M115.500000,140.500000  C115.500000,189.500000 115.500000,238.500000 115.500000,287.500000  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1067.500000,150.000000  C1066.646240,148.956192 1065.487183,149.531891 1064.500000,149.530823  C1030.166626,149.493866 995.833313,149.493866 961.500061,149.530823  C960.512817,149.531891 959.353821,148.956192 958.500000,150.000000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.000000,179.500000  C1136.333374,179.500000 1172.666626,179.500000 1209.000000,179.500000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1098.000000,151.000000  C1097.769775,154.335022 1100.266968,153.463486 1102.000122,153.473587  C1111.499878,153.528976 1121.000000,153.500000 1130.500000,153.500000  C1155.666626,153.500000 1180.833374,153.519623 1205.999878,153.461975  C1207.969727,153.457458 1210.491577,154.435272 1211.500000,151.500000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1291.500000,153.500000  C1291.174927,159.536575 1293.485474,165.426727 1292.271606,171.500000  C1224.000000,171.500000 1155.500000,171.515900 1087.000000,171.455124  C1083.409424,171.451935 1080.258301,171.926254 1078.000000,175.000000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M956.500000,151.500000  C957.239624,153.877563 959.218201,153.495560 961.000000,153.495850  C995.666687,153.501450 1030.333374,153.501450 1065.000000,153.495850  C1066.781860,153.495560 1068.760376,153.877563 1069.500000,151.500000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M94.500000,155.000000  C94.500000,192.333328 94.500000,229.666672 94.500000,267.000000  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,179.500000  C995.333313,179.500000 1031.166626,179.500000 1067.000000,179.500000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M156.000000,145.000000  C156.976685,149.302185 156.464371,153.669006 156.469421,158.000031  C156.519852,201.166641 156.500000,244.333328 156.500000,287.500000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M206.500000,149.500000  C206.500000,194.833328 206.500000,240.166672 206.500000,285.500000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M203.000000,175.500000  C200.937500,177.109375 201.514603,179.401154 201.513443,181.500000  C201.494537,216.166672 201.500000,250.833328 201.500000,285.500000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M210.000000,175.500000  C212.062500,177.109375 211.484909,179.401138 211.486435,181.500015  C211.506714,209.500000 211.500000,237.500000 211.500000,265.500000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M192.500000,140.500000  C192.500000,180.166672 192.495209,219.833328 192.513382,259.500000  C192.514343,261.598846 191.937500,263.890625 194.000000,265.500000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M177.500000,140.500000  C177.500000,189.500000 177.500000,238.500000 177.500000,287.500000  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M136.500000,140.500000  C136.500000,189.500000 136.500000,238.500000 136.500000,287.500000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M129.000000,114.500000  C128.666672,109.666664 128.175400,104.837753 128.040131,99.998878  C127.872536,94.003487 128.000000,87.999840 128.000000,81.750000  C118.339394,81.750000 109.169701,81.750000 99.750000,81.750000  C99.750000,87.991455 99.750000,94.495728 99.750000,101.542061  C108.833336,101.154968 118.166664,102.142731 127.500000,101.000000  "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M541.500000,78.500000  C541.500000,127.500000 541.500000,176.500000 541.500000,225.500000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M805.500000,78.500000  C805.500000,127.666664 805.500000,176.833328 805.500000,226.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M725.000000,154.500000  C729.833313,154.018585 734.660461,154.341141 739.501038,154.384583  C766.332214,154.625427 793.166687,154.500885 820.000000,154.479355  C820.166809,154.479218 820.333374,154.166702 820.644592,153.855499  C819.782959,152.045868 820.036011,150.010895 820.000000,148.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M429.500000,121.500000  C430.333344,121.500000 431.166656,121.500000 431.500000,121.500000  C431.500000,99.669212 431.500000,77.834602 431.500000,55.750000  C426.344086,55.750000 421.172028,55.750000 415.804047,55.750000  C414.378326,104.995102 415.790253,154.500412 415.468719,204.250000  C420.655914,204.250000 425.827972,204.250000 431.250000,204.250000  C431.250000,187.836670 431.250000,171.168335 431.250000,154.500000  C468.000000,154.500000 504.500000,154.500000 541.000000,154.500000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M456.500000,171.500000  C478.833344,171.500000 501.166656,171.500000 523.500000,171.500000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M456.500000,148.000000  C456.500000,155.166672 456.614166,162.336685 456.404053,169.497192  C456.361877,170.934830 456.063202,173.046646 453.499847,173.034760  C450.832855,173.022400 451.001556,171.257233 451.000885,169.500000  C450.998535,163.500000 451.116730,157.496780 450.950989,151.501358  C450.867554,148.484528 452.524872,147.425842 455.004913,147.030823  C456.142700,146.849594 457.333344,147.000000 458.500000,147.000000  C481.500000,147.000000 504.500000,146.997894 527.500000,147.020767  C527.833557,147.021088 528.166809,147.333023 529.000000,147.749146  C529.000000,154.825760 529.001160,162.162872 528.999084,169.500000  C528.998535,171.257233 529.167114,173.022400 526.500183,173.034775  C523.936768,173.046646 523.638184,170.934830 523.596008,169.497177  C523.385864,162.336670 523.500000,155.166672 523.500000,148.000000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M456.500000,121.000000  C456.500000,115.000015 456.500000,109.000038 456.500000,103.160408  C454.500000,102.514267 453.000000,102.007462 451.000000,103.226669  C451.000000,107.988892 450.960968,112.994888 451.017914,117.999794  C451.042999,120.202736 451.730743,121.611389 454.498016,121.648277  C455.752533,121.665001 457.166992,121.976364 458.500031,121.978127  C481.500000,122.008522 504.500000,122.002106 527.500000,121.979256  C527.833557,121.978920 528.166809,121.666992 528.750000,121.375748  C528.750000,115.333336 528.750000,109.166664 528.750000,103.015152  C527.166687,102.247475 525.833313,102.247475 523.500000,103.378784  C523.500000,108.991348 523.500000,114.995674 523.500000,121.000000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M816.500000,121.000000  C816.500000,115.000000 816.500000,109.000000 816.500000,102.889847  C815.093628,101.990906 813.489685,102.759315 811.608032,102.387749  C810.366821,108.794739 811.338806,115.158043 810.864075,122.000000  C836.831116,122.000000 862.165588,122.000000 887.500000,122.000000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1283.000000,177.000000  C1283.717163,170.500000 1283.709961,164.019943 1283.104492,157.490311  C1282.857910,154.829620 1281.891113,153.825226 1279.501465,154.017975  C1266.176880,155.092743 1252.831787,154.206146 1239.500000,154.500000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1214.000000,177.500000  C1232.166626,177.500000 1250.333496,177.479034 1268.499878,177.535248  C1270.157104,177.540390 1271.922485,176.941299 1273.500000,178.000000  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M812.000000,192.000000  C837.166687,192.000000 862.333313,192.000000 887.500000,192.000000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M528.500000,128.000000  C524.722473,126.550079 520.802612,127.613220 517.000305,127.622040  C498.167603,127.665718 479.329346,126.958641 460.495300,127.906837  C457.528809,128.056183 454.500000,126.989883 451.500000,128.000000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M451.500000,141.000000  C455.277527,142.449921 459.197418,141.386780 462.999725,141.377945  C481.832397,141.334274 500.670654,142.041336 519.504700,141.093155  C522.471191,140.943817 525.500000,142.010117 528.500000,141.000000  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1214.000000,179.500000  C1232.166626,179.500000 1250.333496,179.520966 1268.499878,179.464752  C1270.157104,179.459625 1271.922485,180.058701 1273.500000,179.000000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M887.500000,127.500000  C865.001282,127.836357 842.496643,126.939270 819.994995,127.879562  C817.198547,127.996422 814.333313,127.177994 811.500000,128.000000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M887.500000,147.000000  C862.165588,147.000000 836.831116,147.000000 811.250000,147.000000  C811.250000,153.833328 811.250000,160.166672 811.250000,167.000000  C836.831116,167.000000 862.165588,167.000000 887.500000,167.000000  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M811.500000,141.000000  C816.130005,142.193634 820.844421,141.375778 825.500732,141.418259  C846.165710,141.606888 866.833313,141.500000 887.500000,141.500000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M811.500000,186.000000  C816.130005,187.193634 820.844421,186.375778 825.500732,186.418259  C846.165710,186.606888 866.833313,186.500000 887.500000,186.500000  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M950.000000,170.500000  C948.632629,172.329926 946.674561,171.451599 944.999817,171.460251  C931.333496,171.530869 917.665100,171.370438 904.000427,171.534836  C888.998596,171.715332 874.001160,172.354279 858.999695,172.445694  C844.834534,172.532013 830.666687,172.164688 816.500000,172.002640  C814.816833,171.983383 813.133362,172.000000 810.926453,172.000000  C809.889648,170.977707 810.282166,169.255112 811.000000,167.500000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M192.000000,263.500000  C152.000000,263.500000 112.000000,263.500000 71.952744,263.500000  C70.956764,264.541443 71.778931,265.849365 71.336243,267.500000  C79.326241,267.500000 87.173759,267.500000 95.520409,267.500000  C93.160370,273.518677 96.380898,279.781494 92.500000,285.000000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M826.000000,154.500000  C842.000000,154.500000 858.000000,154.500000 874.000000,154.500000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M262.500000,102.000000  C275.155762,102.996521 287.833344,102.347122 300.500214,102.478241  C310.832458,102.585190 321.166656,102.500000 331.500000,102.500000  C353.333344,102.500000 375.166656,102.505569 396.999969,102.478699  C397.833191,102.477676 398.819092,102.928810 399.500000,102.000000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M587.500000,154.000000  C572.341858,154.943405 557.166565,154.323776 542.000000,154.500000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M398.500000,109.000000  C389.847565,108.094070 381.165344,108.496956 372.500336,108.551498  C364.167969,108.603943 355.814514,107.892624 347.500000,109.000000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M392.500000,162.000000  C381.515015,160.841919 370.499176,161.714279 359.499176,161.556641  C355.509583,161.499466 351.461365,160.906082 347.500000,162.000000  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,162.000000  C402.158813,157.413864 398.632324,153.038315 399.636749,148.265839  C396.311584,146.717453 392.808685,147.602188 389.499481,147.581482  C365.333771,147.430191 341.166656,147.500000 317.000000,147.500000  C299.333344,147.500000 281.666656,147.495895 264.000031,147.520966  C263.499786,147.521683 263.000000,147.833344 262.500000,148.000000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M954.000000,166.500000  C955.165833,162.541626 954.096191,158.490112 954.656982,154.000000  C927.998962,154.000000 901.497925,154.000000 874.750000,154.000000  C874.750000,156.310562 874.750000,158.654846 874.750000,161.264954  C875.908447,161.990524 877.505554,161.283142 879.000000,161.500000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,140.500000  C400.089935,136.500000 400.346802,132.500000 399.291382,128.105011  C396.311584,126.717453 392.808685,127.602203 389.499481,127.581490  C365.333771,127.430206 341.166656,127.500000 317.000000,127.500000  C299.333344,127.500000 281.666656,127.495903 264.000031,127.520973  C263.499786,127.521683 263.000000,127.833344 262.500000,128.000015  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M949.000000,172.000000  C949.000000,196.166672 949.000000,220.333328 949.000000,244.500000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M888.500000,171.500000  C888.500000,148.666672 888.500000,125.833336 888.500000,102.889847  C887.093628,101.990906 885.489685,102.759315 883.500000,102.366417  C883.500000,108.824562 883.500000,115.162277 883.500000,121.500000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M186.500000,114.000000  C186.500000,106.000000 186.500000,98.000000 186.500000,89.500000  C172.837402,89.500000 159.168701,89.500000 145.500000,89.500000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M249.500000,288.500000  C237.168579,288.192230 224.820282,289.132172 212.500000,288.000000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M212.000000,154.500000  C228.500000,154.500000 245.000000,154.500000 261.500000,154.500000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M262.500000,141.000000  C275.489288,142.002228 288.500061,141.338943 301.500214,141.479004  C311.332428,141.584961 321.166656,141.500000 331.000000,141.500000  C353.000000,141.500000 375.000000,141.503311 396.999969,141.479111  C397.500153,141.478561 398.000000,141.166656 398.500000,141.000000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M262.500000,154.000000  C275.822601,155.026245 289.167847,154.407471 302.499725,154.377655  C305.125244,154.371796 307.909973,155.393005 310.500000,154.000000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M303.500000,162.000000  C291.833344,161.174881 280.166656,161.174881 268.500000,162.000000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M303.500000,109.000000  C292.180908,107.865295 280.829620,108.597511 269.501343,108.681267  C267.237701,108.698013 264.724884,107.315041 262.500000,109.000000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M262.500000,121.000000  C276.166656,121.707817 289.833344,121.901703 303.500000,121.000000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M354.000000,154.500000  C365.000000,154.500000 376.000000,154.500000 387.000000,154.500000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M64.500000,154.500000  C74.669395,154.500000 84.838799,154.500000 95.133636,154.500000  C94.139038,149.525711 94.615517,145.001892 94.500000,140.500000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M345.500000,109.000000  C334.512146,108.032700 323.495575,108.484116 312.503174,108.678787  C310.226990,108.719101 307.724884,107.315041 305.500000,109.000000  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M898.000000,93.500000  C917.501404,93.500000 937.002869,93.500000 956.500000,93.500000  C956.500000,102.000000 956.500000,110.000000 956.500000,118.000000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M305.500000,121.000000  C316.487854,121.967300 327.504425,121.515877 338.496826,121.321205  C340.773010,121.280891 343.275116,122.684959 345.500000,121.000000  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M339.500000,154.500000  C330.166656,154.500000 320.833344,154.500000 311.500000,154.500000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M842.500000,173.000000  C842.500000,174.333328 842.500000,175.666672 842.500000,177.500000  C835.174255,177.500000 827.837097,177.500000 820.500000,177.500000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M347.000000,101.500000  C346.836853,98.166489 347.417328,94.795799 346.523529,91.500000  C344.500000,91.500000 342.500000,91.500000 340.476471,91.500000  C339.582672,94.795799 340.163147,98.166489 340.000000,101.500000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M311.000000,101.500000  C310.836853,98.166489 311.417328,94.795799 310.523529,91.500000  C308.500000,91.500000 306.500000,91.500000 304.476471,91.500000  C303.582672,94.795799 304.163147,98.166489 304.000000,101.500000  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M888.000000,172.500000  C889.293152,181.980240 887.779968,191.509705 888.673340,201.250000  C885.686218,201.250000 882.843079,201.250000 879.500000,201.250000  C879.500000,198.686218 879.500000,195.843109 879.500000,193.000000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M811.000000,173.000000  C811.070984,182.335037 810.380798,191.683670 811.941040,201.250000  C813.978027,201.250000 816.489014,201.250000 819.500000,201.250000  C819.500000,198.686218 819.500000,195.843109 819.500000,193.000000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M81.500000,285.500000  C118.329559,284.498840 155.166885,285.216339 192.000000,285.000000  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M445.500000,41.500000  C445.500000,48.333332 445.500000,55.166668 445.500000,62.000000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M203.500000,151.000000  C202.295898,153.397079 200.087448,153.005554 198.000000,153.004303  C184.166672,152.995987 170.333328,153.000000 156.500000,153.000000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1233.500000,154.500000  C1226.833374,154.500000 1220.166626,154.500000 1213.500000,154.500000  C1213.500000,164.333328 1213.500000,174.166672 1213.500000,184.000000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M141.500000,153.000000  C126.333336,153.000000 111.166664,153.000000 96.000000,153.000000  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M206.000000,267.000000  C169.390472,270.809662 132.665573,268.272919 96.000000,269.000000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M135.500000,288.000000  C129.166672,288.809692 122.833336,288.809692 116.500000,288.000000  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M176.500000,288.000000  C170.166672,288.809692 163.833328,288.809692 157.500000,288.000000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M114.500000,288.000000  C108.166664,288.809692 101.833336,288.809692 95.500000,288.000000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M400.000000,108.500000  C401.607391,103.716347 398.832031,98.820824 400.356598,93.955070  C400.600891,93.175377 399.788177,90.947128 397.489075,91.450096  C396.216644,91.728455 394.833344,91.500000 393.476471,91.500000  C392.582672,94.795799 393.163147,98.166489 393.000000,101.500000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M201.500000,153.500000  C201.500000,158.500000 201.496506,163.500000 201.501846,168.500000  C201.503784,170.312653 201.189255,172.226562 203.000000,173.500000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M155.500000,288.000000  C149.500000,288.830353 143.500000,288.830353 137.500000,288.000000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M145.500000,109.500000  C150.000000,109.500000 154.506958,109.350464 158.997238,109.559380  C161.459335,109.673927 162.268356,108.435760 161.872894,106.526321  C161.699478,105.688965 161.539581,104.835556 161.523132,103.999542  C161.464127,101.000702 162.711136,96.805313 161.211273,95.284805  C159.053940,93.097771 154.831696,94.705139 151.498871,94.520302  C149.505005,94.409721 147.500000,94.500000 145.500000,94.500000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M210.000000,268.000000  C212.708023,273.526978 211.430298,279.280762 211.032608,285.002258  C210.894577,286.988007 209.581009,286.479675 208.499908,286.487885  C204.500137,286.518311 200.490448,286.330170 196.503052,286.554321  C193.374512,286.730194 192.287216,285.617706 192.445084,282.497223  C192.663742,278.174927 192.500000,273.833344 192.500000,269.500000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M268.000000,101.500000  C267.836853,98.166489 268.417328,94.795799 267.523529,91.500000  C261.810028,91.500000 262.285431,91.534271 261.891937,96.992210  C261.254242,105.838020 261.888641,114.679314 261.795441,123.503120  C261.707794,131.799408 261.112244,140.188126 262.031006,148.496567  C262.530701,153.015793 260.337952,157.500000 262.000000,162.000000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M210.000000,152.500000  C212.908524,155.655930 211.375900,159.509338 211.375900,163.000000  C211.375900,166.490662 212.908524,170.344070 210.000000,173.500000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M398.500000,121.000000  C391.516327,121.852951 384.498230,121.526337 377.500458,121.455215  C367.500519,121.353592 357.483795,122.139763 347.500000,121.000000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1095.000000,156.000000  C1087.666626,156.000000 1080.333374,156.000000 1073.000000,156.000000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M587.000000,177.000000  C588.239624,171.364899 587.039124,165.658020 587.663025,159.500000  C585.844055,159.500000 584.172058,159.500000 582.500000,159.500000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M201.000000,177.500000  C187.833328,177.500000 174.666672,177.500000 161.500000,177.500000  "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M201.000000,171.500000  C187.833328,171.500000 174.666672,171.500000 161.500000,171.500000  "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1078.000000,157.000000  C1079.000000,162.000000 1080.000000,167.000000 1081.000000,172.000000  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M431.000000,154.500000  C421.000000,154.500000 411.000000,154.500000 401.000000,154.500000  "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M143.500000,89.500000  C138.504623,89.805313 133.468063,88.875099 128.500000,90.000000  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M150.500000,153.000000  C150.500000,157.833328 150.500000,162.666672 150.500000,167.500000  "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M129.000000,94.500000  C133.833328,94.500000 138.666672,94.500000 143.500000,94.500000  "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M129.500000,109.500000  C134.166672,109.500000 138.833328,109.500000 143.500000,109.500000  "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M191.500000,288.000000  C187.166672,288.832092 182.833328,288.832092 178.500000,288.000000  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M223.500000,317.500000  C222.762497,319.335419 221.154358,318.436951 219.999481,318.448578  C210.833740,318.540924 201.666672,318.500000 192.500000,318.500000  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M811.000000,122.500000  C811.000000,130.500000 811.000000,138.500000 811.000000,146.500000  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M529.000000,122.500000  C529.000000,130.500000 529.000000,138.500000 529.000000,146.500000  "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M158.500000,170.500000  C153.500000,170.500000 148.500000,170.500000 143.500000,170.500000  "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M879.500000,128.500000  C879.500000,132.666672 879.500000,136.833328 879.500000,141.000000  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M460.000000,128.500000  C460.000000,132.500000 460.000000,136.500000 460.000000,140.500000  "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M340.000000,128.500000  C340.000000,132.500000 340.000000,136.500000 340.000000,140.500000  "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M347.000000,128.500000  C347.000000,132.500000 347.000000,136.500000 347.000000,140.500000  "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M268.000000,128.500000  C268.000000,132.500000 268.000000,136.500000 268.000000,140.500000  "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M393.000000,128.500000  C393.000000,132.500000 393.000000,136.500000 393.000000,140.500000  "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M311.000000,128.500000  C311.000000,132.500000 311.000000,136.500000 311.000000,140.500000  "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M520.000000,128.500000  C520.000000,132.500000 520.000000,136.500000 520.000000,140.500000  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M820.000000,128.500000  C820.000000,132.500000 820.000000,136.500000 820.000000,140.500000  "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M433.500000,112.500000  C432.180481,123.804329 432.553284,135.158432 432.500000,146.500000  "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M304.000000,128.500000  C304.000000,132.500000 304.000000,136.500000 304.000000,140.500000  "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M159.500000,143.500000  C156.201691,143.166260 153.446884,146.274750 150.106369,144.712814  C149.252319,147.000000 149.250275,149.000000 150.000000,151.000000  "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M304.500000,109.500000  C303.501495,113.166664 304.084412,116.833336 304.500000,120.500000  "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M311.000000,109.500000  C311.000000,113.166664 311.000000,116.833336 311.000000,120.500000  "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M340.000000,109.500000  C340.000000,113.166664 340.000000,116.833336 340.000000,120.500000  "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1075.000000,163.500000  C1074.168335,167.166672 1074.168335,170.833328 1075.000000,174.500000  "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1274.500000,178.500015  C1279.166626,178.666672 1283.832764,178.856171 1288.500366,178.987228  C1290.063843,179.031128 1291.719116,179.319199 1293.000000,178.000000  "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M346.500000,109.500000  C347.498505,113.166664 346.915588,116.833336 346.500000,120.500000  "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M393.000000,109.500000  C393.000000,113.166664 393.000000,116.833336 393.000000,120.500000  "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M268.000000,109.500000  C268.000000,113.166664 268.000000,116.833336 268.000000,120.500000  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M821.000000,153.500000  C822.354187,153.500000 823.708313,153.500000 825.250000,153.500000  C825.250000,156.310501 825.250000,158.654846 825.250000,161.264954  C824.091553,161.990524 822.494446,161.283142 821.000000,161.500000  "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M731.500000,155.000000  C732.817749,162.623871 732.467224,170.320267 732.500000,178.000000  "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M450.000000,134.500000  C438.666656,134.500000 427.333344,134.500000 416.000000,134.500000  "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M430.500000,117.500000  C419.500000,117.500000 408.500000,117.500000 397.500000,117.500000  "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M206.500000,140.500000  C206.500000,143.166672 206.500000,145.833328 206.500000,148.500000  "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M142.500000,144.500000  C142.212524,147.326233 143.114304,150.222412 142.000000,153.000000  "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M399.500000,109.500000  C400.515015,113.166664 399.876556,116.833336 399.500000,120.500000  "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M879.500000,173.000000  C879.500000,177.333328 879.500000,181.666672 879.500000,186.000000  "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M215.500000,81.500000  C215.833328,84.000000 216.166656,86.500000 216.500000,89.000000  "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M939.500000,146.500000  C939.500000,151.833328 939.500000,157.166672 939.500000,162.500000  "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M927.500000,85.500000  C927.166626,88.000000 926.833313,90.500000 926.500000,93.000000  "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M820.000000,173.000000  C820.000000,177.166672 820.000000,181.333328 820.000000,185.500000  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M340.000000,148.500000  C340.545532,152.833328 338.515137,157.166672 340.000000,161.500000  "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M311.000000,148.500000  C310.454468,152.833328 312.484863,157.166672 311.000000,161.500000  "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M820.000000,155.000000  C820.000000,158.666672 820.000000,162.333328 820.000000,166.000000  "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M949.000000,161.500000  C949.212097,163.520203 948.363831,165.717148 950.000000,167.500000  "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,121.500000  C400.805634,123.500000 400.805634,125.500000 400.000000,127.500000  "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,141.500000  C400.805634,143.500000 400.805634,145.500000 400.000000,147.500000  "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M345.500000,156.500000  C345.381958,155.486115 345.735840,154.660995 346.230835,154.234131  C348.326630,154.330704 350.172211,154.565536 351.997498,154.457489  C353.799652,154.350815 353.521423,155.442261 353.500000,156.500000  "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M451.000000,122.500000  C451.000000,130.500000 451.000000,138.500000 451.000000,146.500000  "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M879.500000,155.000000  C879.500000,158.833328 879.500000,162.666672 879.500000,166.500000  "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M424.500000,128.500000  C424.500000,132.166672 424.500000,135.833328 424.500000,139.500000  "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M394.500000,156.500000  C394.613770,155.042313 393.858978,153.169388 392.634705,154.165558  C391.004333,155.492126 387.426239,152.185822 387.500000,156.500000  "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M340.500000,154.000000  C342.166656,154.333344 343.833344,154.666672 345.500000,155.000000  "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M737.500000,159.500000  C735.843689,159.770111 734.077454,158.941299 732.500000,160.000000  "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M879.500000,148.000000  C879.227905,149.488281 880.115540,151.105438 879.000000,152.500000  "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M395.000000,154.500000  C396.152435,154.233810 397.462982,155.074142 398.500000,154.000000  "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M140.500000,171.500000  C139.333328,171.500000 138.166672,171.500000 137.000000,171.500000  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M950.000000,239.500000  C951.166687,239.500000 952.333313,239.500000 953.500000,239.500000  "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M436.500000,147.500000  C434.005188,148.296997 431.924042,146.198349 429.500000,146.500000  "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M140.500000,177.500000  C139.333328,177.500000 138.166672,177.500000 137.000000,177.500000  "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M443.500000,130.500000  C443.500000,132.833328 443.500000,135.166672 443.500000,137.500000  "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M417.500000,130.500000  C415.500000,130.500000 413.500000,130.500000 411.500000,130.500000  "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M404.500000,115.500000  C404.500000,116.833336 404.500000,118.166664 404.500000,119.500000  "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,199.500000  C957.365051,200.599640 959.056641,202.549622 958.286621,204.250000  C994.665100,204.250000 1030.832520,204.250000 1067.269897,204.250000  C1068.009155,203.093597 1067.240723,201.489700 1067.633545,199.500000  C1031.668213,199.500000 995.834106,199.500000 960.000000,199.500000  "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,230.000000  C957.848389,231.003769 958.755432,232.647186 958.445129,234.250000  C994.665100,234.250000 1030.832520,234.250000 1067.230591,234.250000  C1067.992554,233.000000 1067.485718,231.500000 1067.000488,230.000000  C1031.333374,230.000000 995.666687,230.000000 960.000000,230.000000  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,222.000000  C1098.848389,223.003769 1099.755371,224.647186 1099.445190,226.250000  C1135.998535,226.250000 1172.499268,226.250000 1209.230591,226.250000  C1209.992554,225.000000 1209.485718,223.500000 1209.000488,222.000000  C1173.000000,222.000000 1137.000000,222.000000 1101.000000,222.000000  "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,222.000000  C957.848389,223.003769 958.755432,224.647186 958.445129,226.250000  C994.665100,226.250000 1030.832520,226.250000 1067.230591,226.250000  C1067.992554,225.000000 1067.485718,223.500000 1067.000488,222.000000  C1031.333374,222.000000 995.666687,222.000000 960.000000,222.000000  "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,214.500000  C1098.365112,215.599640 1100.056641,217.549622 1099.286621,219.250000  C1135.998535,219.250000 1172.499268,219.250000 1209.269897,219.250000  C1210.009155,218.093597 1209.240723,216.489700 1209.633545,214.500000  C1173.334839,214.500000 1137.167480,214.500000 1101.000000,214.500000  "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,161.500000  C957.365051,162.599640 959.056641,164.549622 958.286621,166.250000  C994.665100,166.250000 1030.832520,166.250000 1067.269897,166.250000  C1068.009155,165.093597 1067.240723,163.489700 1067.633545,161.500000  C1031.668213,161.500000 995.834106,161.500000 960.000000,161.500000  "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,161.500000  C1098.365112,162.599640 1100.056641,164.549622 1099.286621,166.250000  C1135.998535,166.250000 1172.499268,166.250000 1209.269897,166.250000  C1210.009155,165.093597 1209.240723,163.489700 1209.633545,161.500000  C1173.334839,161.500000 1137.167480,161.500000 1101.000000,161.500000  "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,214.500000  C957.365051,215.599640 959.056641,217.549622 958.286621,219.250000  C994.665100,219.250000 1030.832520,219.250000 1067.269897,219.250000  C1068.009155,218.093597 1067.240723,216.489700 1067.633545,214.500000  C1031.668213,214.500000 995.834106,214.500000 960.000000,214.500000  "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,207.000000  C1098.848389,208.003769 1099.755371,209.647186 1099.445190,211.250000  C1135.998535,211.250000 1172.499268,211.250000 1209.230591,211.250000  C1209.992554,210.000000 1209.485718,208.500000 1209.000488,207.000000  C1173.000000,207.000000 1137.000000,207.000000 1101.000000,207.000000  "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,207.000000  C957.848389,208.003769 958.755432,209.647186 958.445129,211.250000  C994.665100,211.250000 1030.832520,211.250000 1067.230591,211.250000  C1067.992554,210.000000 1067.485718,208.500000 1067.000488,207.000000  C1031.333374,207.000000 995.666687,207.000000 960.000000,207.000000  "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,199.500000  C1098.365112,200.599640 1100.056641,202.549622 1099.286621,204.250000  C1135.998535,204.250000 1172.499268,204.250000 1209.269897,204.250000  C1210.009155,203.093597 1209.240723,201.489700 1209.633545,199.500000  C1173.334839,199.500000 1137.167480,199.500000 1101.000000,199.500000  "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,192.000000  C1098.848389,193.003769 1099.755371,194.647186 1099.445190,196.250000  C1135.998535,196.250000 1172.499268,196.250000 1209.230591,196.250000  C1209.992554,195.000000 1209.485718,193.500000 1209.000488,192.000000  C1173.000000,192.000000 1137.000000,192.000000 1101.000000,192.000000  "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M249.500000,261.500000  C247.216919,263.554810 248.737427,266.180023 248.579330,268.505402  C248.297348,272.652893 248.500000,276.833344 248.500000,281.250000  C261.662445,281.250000 274.831238,281.250000 288.250000,281.250000  C288.250000,275.008545 288.250000,268.504272 288.250000,261.500000  C275.670990,261.500000 262.835510,261.500000 250.000000,261.500000  "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M959.500000,237.000000  C957.848389,238.003769 958.755432,239.647186 958.445129,241.250000  C994.665100,241.250000 1030.832520,241.250000 1067.230591,241.250000  C1067.992554,240.000000 1067.485718,238.500000 1067.000488,237.000000  C1031.333374,237.000000 995.666687,237.000000 960.000000,237.000000  "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,230.000000  C1098.848389,231.003769 1099.755371,232.647186 1099.445190,234.250000  C1135.998535,234.250000 1172.499268,234.250000 1209.230591,234.250000  C1209.992554,233.000000 1209.485718,231.500000 1209.000488,230.000000  C1173.000000,230.000000 1137.000000,230.000000 1101.000000,230.000000  "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1100.500000,237.000000  C1098.848389,238.003769 1099.755371,239.647186 1099.445190,241.250000  C1135.998535,241.250000 1172.499268,241.250000 1209.230591,241.250000  C1209.992554,240.000000 1209.485718,238.500000 1209.000488,237.000000  C1173.000000,237.000000 1137.000000,237.000000 1101.000000,237.000000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSch);
export default __webpack_public_path__ + "static/media/sch.46e2367ba67a905fc70166989e6fda5c.svg";
export { ForwardRef as ReactComponent };